import React, { useEffect, useState } from 'react';
import { MealAddonCategoryType } from 'utils/types';
import PageText from 'components/base/page-text';
import DeleteModal from 'components/base/delete-modal';
import SearchNav from 'components/search-nav';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';
import TrashedAddonCategoryCard from 'components/base/trashed-addon-category-card';

const TrashedAddonCategories = () => {
  const { activeCokitchen } = useDashboardContext();

  const [categoryList, setCategoryList] = useState([] as MealAddonCategoryType[]);
  const [selectedItems, setSelectedItems] = useState([] as string[]);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeCategory, setActiveCategory] = useState({} as MealAddonCategoryType);

  const fetchData = async () => {
    setLoading(true);
    const payload = { type: 'addon_category', cokitchen_id: activeCokitchen?.id };
    try {
      const res: any = await apiService.post('marketing/get-archived-items', { data: payload });
      const response = res?.data?.data;
      if (response) {
        setCategoryList(res?.data?.data.reverse());
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [activeCokitchen?.id]);

  useEffect(() => {
    if (activeCategory?.id) {
      restoreModal();
    }
  }, [activeCategory?.id]);

  const handleChange = (category: MealAddonCategoryType) => {
    //if (singleMeal?.id) setSingleMeal(null);
    const resultExists = selectedItems.find((id) => id === category.id);
    if (resultExists) {
      setSelectedItems(selectedItems.filter((id) => id !== category.id));
    } else {
      setSelectedItems([...selectedItems, category.id]);
    }
  };
  const handleRestoreClick = async () => {
    setLoading(true);
    const itemIds = selectedItems.length > 0 ? selectedItems : [activeCategory.id];
    const payload = { type: 'addon_category', item_ids: itemIds };
    try {
      const res: any = await apiService.post('marketing/restore-bulk-items', { data: payload });
      if (res.data) {
        setCategoryList((prev) => prev?.filter(({ id }) => id !== activeCategory.id));
        toast(
          <ToastMessage
            type='success'
            message={`Restored ${activeCategory.name || 'items'} successfully `}
          />
        );
        setSelectedItems([]);
        fetchData();
        restoreModal();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const restoreModal = () => {
    setShowRestoreModal(!showRestoreModal);
    if (showRestoreModal) {
      setActiveCategory({} as MealAddonCategoryType);
    }
  };
  const removeAll = () => {
    setSelectedItems([]);
  };
  const handleSelectAll = () => {
    const allIds: string[] = categoryList?.map((item: any) => item.id);
    setSelectedItems(allIds);
  };
  return (
    <div>
      {loading ? (
        <PageText text='Loading...' />
      ) : categoryList.length === 0 && !loading ? (
        <PageText text='No addon category found' />
      ) : (
        <div className='grid md:grid-cols-2 gap-4 items-center flex-wrap'>
          {categoryList?.map((item) => (
            <TrashedAddonCategoryCard
              data={item}
              selectedItems={selectedItems}
              onChange={() => handleChange(item)}
              key={item.id}
              onRestore={() => setActiveCategory(item)}
            />
          ))}
        </div>
      )}
      <DeleteModal
        show={showRestoreModal}
        type='restore'
        onClose={restoreModal}
        handleDelete={handleRestoreClick}
        title={`Are you sure you want to restore ${
          !activeCategory.name ? 'items' : activeCategory?.name
        } `}
        description='This action will restore this addon category'
        loading={loading}
      />
      {selectedItems.length > 0 && (
        <SearchNav
          count={selectedItems.length}
          handleSelectAll={handleSelectAll}
          onRestoreClick={restoreModal}
          onDoneClick={removeAll}
        />
      )}
    </div>
  );
};

export default TrashedAddonCategories;
